import { render } from "./DialogSewage.vue?vue&type=template&id=6a4f947c&scoped=true"
import script from "./DialogSewage.vue?vue&type=script&lang=js"
export * from "./DialogSewage.vue?vue&type=script&lang=js"

import "./DialogSewage.vue?vue&type=style&index=0&id=6a4f947c&lang=scss&scoped=true"
import "./DialogSewage.vue?vue&type=style&index=1&id=6a4f947c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a4f947c"]])

export default __exports__